import { render } from "./CancelRemovalModal.vue?vue&type=template&id=5627bba6&scoped=true"
import script from "./CancelRemovalModal.vue?vue&type=script&lang=js"
export * from "./CancelRemovalModal.vue?vue&type=script&lang=js"

import "./CancelRemovalModal.vue?vue&type=style&index=0&id=5627bba6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5627bba6"]])

export default __exports__